export default "__VITE_ASSET__D5LtFUL8__"